export default __webpack_public_path__ + "static/media/Ten.56b657a9.svg";